module.exports = __webpack_public_path__ + "img/body-3.e35a1c12.png";